angular.module("vgresiduos").controller("AuditTrailListCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `master/audit-trail`);
		};
	}
]);
